<div class="content-block">
    <div class="dx-card responsive-paddings">

        <div class="content-grid">
            <div style="display: flex; justify-content: space-between;">
                <h2 class="content-block">Pricelist</h2>
            </div>

            <dx-data-grid class="dx-card wide-card" [dataSource]="pricelistStandardDataSource" [showBorders]="false"
                [focusedRowEnabled]="true" [focusedRowIndex]="0" [columnAutoWidth]="true" [columnHidingEnabled]="true"
                keyExpr="Id">
                <dxo-paging [pageSize]="15"></dxo-paging>
                <dxo-pager [visible]="true" [showPageSizeSelector]="true"></dxo-pager>
                <dxo-editing mode="popup" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
                    <dxo-popup title="Employee Info" [showTitle]="true" [width]="700" [height]="525">
                    </dxo-popup>
                    <dxo-paging [pageSize]="10"></dxo-paging>
                    <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>

                    <dxo-form>
                        <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
                            <dxi-item dataField="ServiceId"></dxi-item>
                            <dxi-item dataField="BillingTypeId"></dxi-item>
                            <dxi-item dataField="Description" editorType="dxTextArea" [colSpan]="2"
                                [editorOptions]="{ height: 100 }">
                            </dxi-item>
                            <dxi-item dataField="Tiered"> </dxi-item>
                            <dxi-item dataField="TierType"> </dxi-item>
                            <dxi-item dataField="TierMin"> </dxi-item>
                            <dxi-item dataField="TierMax"> </dxi-item>
                            <dxi-item dataField="Cycle"></dxi-item>
                            <dxi-item dataField="Recurring"> </dxi-item>
                            <dxi-item dataField="Rate"> </dxi-item>
                            <dxi-item dataField="Status"> </dxi-item>
                            <dxi-item dataField="StartDate"> </dxi-item>
                            <dxi-item dataField="EndDate"> </dxi-item>
                        </dxi-item>
                    </dxo-form>
                </dxo-editing>

                <dxi-column dataField="ServiceId" caption="Service">
                    <dxo-lookup [dataSource]="serviceDataSource" displayExpr="Name" valueExpr="Id"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="BillingTypeId" caption="Billing Types">
                    <dxo-lookup [dataSource]="billingTypeDataSource" displayExpr="Description"
                        valueExpr="Id"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="Description" caption="Description">
                </dxi-column>
                <dxi-column dataField="Tiered" caption="Tiered" dataType="boolean"> </dxi-column>
                <dxi-column dataField="TierType" caption="Tier Type">
                    <dxo-lookup [dataSource]="priceListTierType" displayExpr="Name" valueExpr="Id"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="TierMin" caption="Tier Min"> </dxi-column>
                <dxi-column dataField="TierMax" caption="Tier Max"> </dxi-column>
                <dxi-column dataField="Cycle" caption="Cycle">
                    <dxo-lookup [dataSource]="priceListCycle" displayExpr="Name" valueExpr="Id"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="Recurring" caption="Recurring" dataType="boolean">
                </dxi-column>
                <dxi-column dataField="Rate" caption="Rate" dataType="number"
                    [editorOptions]="{ format: '#,##0.##', showSpinButtons: true }">
                </dxi-column>
                <dxi-column dataField="Status" caption="Status">
                    <dxo-lookup [dataSource]="priceListStatusType" displayExpr="Name" valueExpr="Id"></dxo-lookup>
                </dxi-column>
                <dxi-column dataField="StartDate" caption="Start Date" dataType="date">
                </dxi-column>
                <dxi-column dataField="EndDate" caption="End Date" dataType="date">
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>
</div>